<app-dvs-chart #chart [options]="vshaft?.plotOptions" loading="Loading vibration data..." [height]="'600px'"></app-dvs-chart>
@if (vshaft?.plotOptions) {
<div class="chart-legend">
	<span class="legend-item">
		<span class="swatch square"></span> {{avgLabel}}
	</span>
	<span class="legend-item">
		<span class="swatch diamond"></span> {{predLabel}}
	</span>
</div>
}
@if (!disableDownload) {
<button (click)="DownloadData(vshaft)" title="Download a text output of the RTB average and predictions" class="button block mt-3">Download CSV</button>
}